<div class="share-referral-link">
  <air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
  <div *ngIf="content.description" [outerHTML]="content.description"></div>

  <div class="referral__link" *ngIf="!isLoading; else loading">
    <input #copyElement type="text" (click)="copyLink()" (wheel)="hasFocus()" [value]="inviteLink" class="referral__link--value" readonly />

    <div class="button__group">
      <button type="button" (click)="copyLink($event)" class="button button--cta button--full-width">
        {{ "referral.form.button.copy" | translate }}
      </button>
      <button *ngIf="canShare" type="button" (click)="shareLink($event)" class="button button--tertiary button--full-width">
        {{ "referral.form.button.more_options" | translate }}
      </button>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="referral__link loading">
    <p class="loader--skeleton">{{ "general.label.loading" | translate }}</p>
    <p class="loader--skeleton">{{ "general.label.loading" | translate }}</p>
  </div>
</ng-template>
